import { render, staticRenderFns } from "./ayuda.vue?vue&type=template&id=cef3c876&scoped=true&"
import script from "./ayuda.vue?vue&type=script&lang=js&"
export * from "./ayuda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef3c876",
  null
  
)

export default component.exports